<template>
  <main 
  v-if="page"
  id="content" 
  aria-labelledby="main-title"
  >
    
    <article>
      
      <ElementHeroBlog :content="page" />

      <Container class="px-0 pl-4 sm:pl-8 sm:px-0 md:px-8">
        <div class="md:grid md:grid-cols-12 lg:grid-cols-12 gap-8 relative">
          <ElementTableOfContents />
          <div class="md:col-start-4 md:col-span-9 lg:col-start-4 lg:col-span-8 relative">

            <template v-if="page?.dynamic">
              <template v-for="(section, index) in page?.dynamic">
                <ElementComparisonTable v-if="section?.item?.component == 'ComparisonTable'" />
                <component v-else :is="getSectionComponent(section.collection)" 
                :sectionIndex="index" 
                :content="section.item" 
                :sectionTotal="page.dynamic.length"
                />
              </template>
            </template>

          </div>
        </div>
      </Container>

    </article>

    <BlockArticlesRelated
    v-if="pageCat"
    :category="pageCat" 
    :exclude="excludeSlug" 
    />

    <!-- <ElementLeaveDetails type="newsletter" /> -->
    
  </main>
</template>

<script setup>
const { $seo } = useNuxtApp()
const { getItems } = useDirectusItems()
const fields = useFields()
const route = useRoute()

const contentSections = useContentSections()

const excludeSlug = computed(() => {
  return route.params.slug
})

const { data } = await useAsyncData(
  'article-'+route.params.slug,
  () => getItems({
    collection: 'article',
    params: {
      filter: {
        slug: {
          "_eq": route.params.slug
        },
        status: {
          _in: useRuntimeConfig().public.postStatus
        },
      },
      fields
    }
  })
)

if (!data.value || !data.value.length) {
  throw createError({
    statusCode:404
  })
}

const page = data?.value[0]

const pageCat = computed(() => {
  if (page?.categories?.length) {
    return page?.categories[0].category_id.slug
  }
  return null
})

const seo = computed(() => {
  if (page?.seo) {
    return $seo(page.seo, route.fullPath)
  }
  return {}
})

useHead(seo)

useSchemaOrg([
  defineArticle({
    '@type': 'BlogPosting',
    headline: page.value?.seo?.meta_title,
    image: page.value?.seo?.meta_image?.id ? useCdn(page.value?.seo?.meta_image.id, page.value?.seo?.meta_image.filename_download) : null,
    description: page.value?.seo?.meta_description,
    datePublished: page.value?.date,
    dateModified: page.value?.date
  })
])

const getSectionComponent = key => {
  return contentSections[key]
}
</script>